import { z } from 'zod';

export const IntegrationAddOnSchema = z.object({
  code: z.string(),
  available: z.boolean(),
  description: z.string(),
  name: z.string().optional(),
});
export type IntegrationAddOn = z.infer<typeof IntegrationAddOnSchema>;

export const IntegrationAddOnsResponseSchema = z.object({
  items: z.array(IntegrationAddOnSchema),
});
